import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryModal(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-modal',
    alias: 'factoryModal',
    loader: i18nLoader,
  });
}
